var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Tooltip.module.scss';
import { createPortal } from 'react-dom';
var Tooltip = function (_a) {
    var children = _a.children, text = _a.text, _b = _a.position, position = _b === void 0 ? 'bottom' : _b, className = _a.className, id = _a.id, dataId = _a.dataId;
    var posClass = styles["".concat(position.charAt(0).toUpperCase()).concat(position.slice(1))];
    var _c = useState({}), style = _c[0], setStyle = _c[1];
    var _d = useState(false), showTooltip = _d[0], setShowTooltip = _d[1];
    var wrapperRef = useRef(document.createElement('div'));
    var elRef = useRef(document.createElement('div'));
    var mouseEnter = function () {
        setShowTooltip(true);
    };
    var mouseLeave = function () {
        setShowTooltip(false);
    };
    useEffect(function () {
        var _a;
        var stylesState = { top: 20, left: 20, opacity: 0 };
        var pos = wrapperRef.current.getBoundingClientRect();
        if (showTooltip) {
            var element = (_a = elRef === null || elRef === void 0 ? void 0 : elRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            // left right positions
            if (element && position === 'left') {
                stylesState.top = pos.y + pos.height / 2 - element.height / 2;
                stylesState.left = pos.x - 10 - element.width;
            }
            if (element && position === 'right') {
                stylesState.top = pos.y + pos.height / 2 - element.height / 2;
                stylesState.left = pos.x + pos.width + 10;
            }
            // top bottom positions
            if (element && position === 'top') {
                stylesState.left = pos.x + pos.width / 2 - element.width / 2;
                stylesState.top = pos.y - 14 - element.height;
            }
            if (element && position === 'bottom') {
                stylesState.left = pos.x + pos.width / 2 - element.width / 2;
                stylesState.top = pos.y + pos.height + 14;
            }
            stylesState.opacity = 1;
        }
        setStyle(stylesState);
    }, [showTooltip]);
    return (_jsxs("div", __assign({ className: "".concat(styles.Tooltip, " ").concat(className || ''), id: id, "data-testid": dataId }, { children: [_jsx("div", __assign({ "data-testid": 'tooltip-wrapper', ref: wrapperRef, onMouseEnter: mouseEnter, onMouseLeave: mouseLeave }, { children: children })), showTooltip &&
                createPortal(_jsx("div", __assign({ style: style, ref: elRef, className: "".concat(styles.TooltipContent, " ").concat(posClass) }, { children: _jsx("div", { children: text }) })), document.getElementById('tooltip-root'))] })));
};
Tooltip.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map